/** Triggers a browser download of a same-origin static file (e.g. a PDF in /public). */
export function downloadFile(url: string, filename?: string) {
  if (typeof document === "undefined") return;

  const link = document.createElement("a");
  link.href = url;
  if (filename) link.download = filename;
  else link.download = "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
